import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import FeedOrdersList from './FeedOrdersList';

const FeedOrdersUnified = ({ user, ...props }) => {
  // All users now see the unified feed orders view
  return <FeedOrdersList {...props} />;
};

FeedOrdersUnified.propTypes = {
  user: T.object.isRequired,
};

export default connect(
  (state) => ({
    user: state.auth.user,
  })
)(FeedOrdersUnified);
